module.exports = __webpack_public_path__ + "static/media/loader.1eb55e49.svg";